import { Box, Button, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import '../css/pages/NotFoundPage.scss'
// import { Link } from 'react-router-dom'
export default function NotFoundPage() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: 'center' }}>
            <video autoPlay muted>
                <source src='assets/video/404.mp4' type="video/mp4" />
            </video>
            <Stack spacing={1} alignItems='center' sx={{ mt: 2 }}>
                <Typography color='primary' variant='h4'>What on earth are you doing here!</Typography>
                <Typography variant='subtitle2'>Well, this is awkward, the page you were trying to view does not exist.</Typography>
                <Link href="/"><Button>Back to home</Button></Link>
            </Stack>
        </Box>
    )
}
